module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020ZH-12.1fb44a75.jpg";